export const getSelf = (loc = 'ybApi', config = {}) => ({
  endpoint: '/users/self',
  loc,
  ...config,
});

export const getWorkspaceList = (userId, loc = 'ybApi', config = {}) => ({
  endpoint: `/users/${userId}/organisations`,
  requestKey: 'GET_WORKSPACE_LIST',
  resourceType: 'workspaceList',
  apiResource: 'organisations',
  resourceAction: 'READ_RESOURCES',
  loc,
  ...config,
});

export const getWorkspaceMemberProfile = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}/members/self/profile`,
  loc,
  ...config,
});

export const getWorkspaceDetail = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}`,
  resourceAction: 'READ_RESOURCES',
  requestKey: `READ_WORKSPACE_DETAIL_${workspaceId}`,
  resourceType: 'workspaceDetail',
  resources: [workspaceId],
  loc,
  ...config,
});

export const getTemplateList = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}/cmrs`,
  requestKey: 'GET_TEMPLATE_LIST',
  resourceType: 'templateList',
  apiResource: 'cmrs',
  resourceAction: 'READ_RESOURCES',
  loc,
  ...config,
});
